import { Reservation } from '../Types/reservationTypes';

type ReservationPartyLookupSource = Pick<
  Reservation,
  'applicantPartyId' | 'invoiceBuyerPartyId' | 'fundingPartyId'
>;

export const getReservationPartyLookupIds = (
  reservation: ReservationPartyLookupSource
): number[] =>
  [reservation.applicantPartyId, reservation.invoiceBuyerPartyId, reservation.fundingPartyId]
    .map((value) => Number(value))
    .filter(
      (value, index, values) =>
        Number.isInteger(value) && value > 0 && values.indexOf(value) === index
    );